import React from "react"
import { Icon } from "antd"

const FullPageContentLoader = (props) => (
  <div style={{ width: "100%", height: "100vh" }}>
    <div className="content-loader">
      <Icon type="loading" /> <h3>Please wait...</h3>
    </div>
  </div>
)

export default FullPageContentLoader
